<div class="container container-fluid mt-3" id="rechazo">
    <div class="p-4 mb-3 rounded">
        <div class="row justify-content-center my-3">
            <div class="col-12 mb-2">
                <button class="btn btn-info text-uppercase font-weight-bold float-right" (click)="backPage()">
                    <i class="fa fa-list" aria-hidden="true"></i> Lista
                </button>
                <h4 class="text-center text-secondary text-uppercase font-weight-bold">Solicitud</h4>
            </div>
        </div>
        <br>
        <div class="card">
            <div class="card-header" role="tab" data-toggle="collapse" aria-expanded="false">
                <h6 class="mb-0">Informacion</h6>
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                <label> Cliente </label>
                <input type="text" class="form-control" [value]="cPago.clientName" disabled>
            </div>
            <div class="col">
                <label> No. identificación </label>
                <input type="text" [value]="cPago.documentNumber" class="form-control" disabled>
            </div>
            <div class="col-2">
                <label> No. solicitud </label>
                <input type="text" class="form-control" [value]="cPago.id" disabled>
            </div>
            <div class="col-2">
                <label> Estado </label>
                <input type="text" class="form-control" [value]="cPago.status" disabled>
            </div>
        </div>
        <div class="row">
            <div class="col-4 mt-3">
                <label> Motivo </label>
                <textarea class="form-control" cols="30" rows="2.5" [(ngModel)]="cPago.reason"
                    [disabled]="mode !='editar'"></textarea>
                <label class="form-check-label pl-4 py-2" for="defaultCheck">
                    <input class="form-check-input" type="checkbox" (change)="viewForm($event)" id="defaultCheck">
                    Ver Formulario
                </label>
            </div>
            <div class="col mt-3 container-buttons">
                <div class="buttons" *ngIf="mode === 'editar'">
                    <a (click)="finishPetition()" class="btn btn-primary text-light ml-2" type="submit">
                        Carga de Nuevo la Solicitud
                    </a>
                    <a (click)="finishPetition(true)" class="btn btn-primary text-light ml-2" type="button">
                        Cierre Definido
                    </a>
                    <button class="btn btn-primary text-light ml-2" [routerLink]="['/capacidad-pago-edit/' + paymentView.id]" >
                        Editar Formulario
                    </button>
                </div>
            </div>
            <!-- <app-capacidad-pago-m [viewMode]="true" [paymentCapacity]="paymentView" *ngIf="viewPayment"></app-capacidad-pago-m> -->
            <app-capacidad-pago [idPC]="cPago.id" [modal]="true" *ngIf="viewPayment"></app-capacidad-pago>
        </div>
    </div>
    <ngx-spinner color="#c2af85" size="medium" type="ball-fussion">
        <p class='color-spinner-text'>Cargando... </p>
    </ngx-spinner>
</div>